import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { Modal } from '../../components';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';

const CONTACT_USER_LINK = 'inquiryModalContactUserLink';

/**
 * Inquiry modal for contacting the listing author.
 *
 * @component
 */
const ListingInquiryModal = props => {
  const {
    title,
    authorDisplayName,
    isOpen,
    onClose,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    onManageDisableScrolling,
  } = props;

  return (
    <Modal
      id="ListingPage.inquiry"
      contentClassName={css.inquiryModalContent}
      isOpen={isOpen}
      onClose={onClose}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      focusElementId={CONTACT_USER_LINK}
    >
      <InquiryForm
        className={css.inquiryForm}
        submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
        listingTitle={title}
        authorDisplayName={authorDisplayName}
        sendInquiryError={sendInquiryError}
        onSubmit={onSubmitInquiry}
        inProgress={sendInquiryInProgress}
      />
    </Modal>
  );
};

export default ListingInquiryModal;
